import { combineReducers } from 'redux'

import ui from 'state/reducers/ui'
import {
  agent,
  project,
  organisation,
  session
} from 'general/state/reducers'
import {
  analyticsSessions,
  analyticsHandoff,
  analyticsTag,
  analyticsUsers,
  analyticsInteractions,
  analyticsMessages,
  analyticsSentiments,
  analyticsOverview,
  analyticsExport,
  analyticsOpeningEvents,
  analyticsResolvedByBot
} from 'analytics/state/reducers'

export default combineReducers({
  agent,
  project,
  
  analyticsSessions,
  analyticsHandoff,
  analyticsTag,
  analyticsUsers,
  analyticsInteractions,
  analyticsMessages,
  analyticsSentiments,
  analyticsOverview,
  analyticsExport,
  analyticsOpeningEvents,
  analyticsResolvedByBot,

  organisation,
  session,
  ui
})
